import { IApplicationState } from '../../types/redux';

export const selectSeoTitle = (state: IApplicationState) => {
  return state.seo.pageData?.title ?? '';
};
